module.exports = __webpack_public_path__ + "static/media/t_v.b914c17.mp4";


//////////////////
// WEBPACK FOOTER
// ./static/img/t_v.mp4
// module id = l8XG
// module chunks = 1